import I from '../types.ts';

const filterItem: I['filterItem'] = function (item, key) {
    const { counterScroll } = this.state;

    return key < counterScroll;
};

export default filterItem;
